import api from '../api';
import { queryToString } from 'helpers/AppHelpers';

export const searchMatchesApi = (query) =>
  api.get(`/Search?${queryToString(query)}`).then((res) => res.data);
